import {Component, OnInit, ViewChild} from '@angular/core';

import {AppSettingsService, BaseComponent, Message} from 'iui-iconectiv-lib';
import {SummaryService} from "../summary/summary.service";
import {Account} from "../shared/model/account.model";
import {Tier} from "../shared/model";
import { SelectItem } from 'primeng/api/selectitem';
import {FeeScheduleService} from "../shared/fee-schedule";
import {AccountCompletionService} from "../account-completion";


@Component({
  selector: 'admin-account',
  templateUrl: './admin-account.component.html',
  styleUrls: ['./admin-account.component.scss']
})
export class AdminAccountComponent extends BaseComponent implements OnInit {

  @ViewChild('accountForm') accountForm;

  selectedAccount: Account = new Account();
  selectedAccountCopy: Account = new Account();
  tier: string;
  serviceAgreementUrl: string;
  customTier: Tier;

  tiers: SelectItem[];

  nameValidatorPattern = Account.nameValidatorPattern;
  phoneValidatorPattern = Account.phoneValidatorPattern;
  zipCodeValidatorPattern = Account.zipCodeValidatorPattern;

  ACCOUNT_TYPE_STANDARD = Account.ACCOUNT_TYPE_STANDARD.value;
  ACCOUNT_TYPE_NON_STANDARD = Account.ACCOUNT_TYPE_NON_STANDARD.value;

  // '# Regional User Agreement(s)' text
  numOfRua: string = this.getRuaDisplay();
  usageTierUpdateLimit: number = 0;

  accountBeingEdited: boolean = false;
  tierBeingEdited: boolean = false;
  sameAsAccount: boolean = false;

  constructor(private summaryService: SummaryService,
              private feeScheduleService: FeeScheduleService,
              private accountCompletionService: AccountCompletionService,
              private appSettings: AppSettingsService) {
    super();

    this.accountCompletionService.getServiceAgreementUrl().subscribe(url => {
      this.serviceAgreementUrl = url;
    });
  }

  ngOnInit(): void {

    this.summaryService.getMyAccount().subscribe(
      resp => {
        if (resp['status'] === 'fail') {
          // prepare error message
          const message: any = resp['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`AdminAccountComponent(): errorMessage=${errorMessage}`);
          this.displayError();
        } else {
          this.selectedAccount = resp['Account'] || null;
          if (this.selectedAccount != null) {
            this.selectedAccountCopy = JSON.parse(JSON.stringify(this.selectedAccount));
            this.tier = this.selectedAccountCopy.tier;
            this.customTier = this.selectedAccountCopy.custom;
          } else {
            this.log.error(`AdminAccountComponent(): account is empty`);
            this.displayError();
          }
        }
      },
      error => {
        this.log.error(`AdminAccountComponent(): got HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );

    //Init tiers
    this.feeScheduleService.getFeeScheduleList().subscribe(
      resp => {
        if (resp['status'] === 'fail') {
          // prepare error message
          const message: any = resp['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`feeScheduleList(): errorMessage=${errorMessage}`);
        } else {
          var fees = resp['feeSchedule'] || null;

          if (fees === null) {
            this.log.error(`feeScheduleList(): fee schedule list is empty`);
          }
          else {
            this.tiers = fees.map(function (fee) {
              return {label: fee.tierName.replace(/([^0-9])([0-9])/g, '$1 $2'), value: fee.tierName}; //Tier1 -> Tier 1
            });
            this.tiers.push({label: "Custom", value: "Custom"}); //For non-standard tiers
          }
        }
      },
      error => {
        this.log.error(`feeScheduleList(): got HttpError=${JSON.stringify(error)}`);
      }
    );

    //Get the last day when tier can be updated
    this.appSettings.getSettings().subscribe(s => {
      this.usageTierUpdateLimit = s['usageTierUpdateLimit'];
    });
  }

  /**
   * generate RUA display string
   */
  getRuaDisplay(): string {
    const numOfRua = this.selectedAccount && this.selectedAccount.ruaList && this.selectedAccount.ruaList.length || 0;

    return numOfRua > 1
      ? numOfRua + ' Regional User Agreements'
      : numOfRua + ' Regional User Agreement';
  }

  // billing info set same as contact info
  sameAsAccountInfo(event) {
    this.sameAsAccount = event.checked;

    // if user wants billing same as contact information
    if(event.checked == true) {
      this.selectedAccountCopy.billingFirstName = this.selectedAccountCopy.firstName;
      this.selectedAccountCopy.billingLastName = this.selectedAccountCopy.lastName;
      this.selectedAccountCopy.billingEmail = this.selectedAccountCopy.email;
      this.selectedAccountCopy.billingPhone = this.selectedAccountCopy.phone;
      this.selectedAccountCopy.billingCountry = this.selectedAccountCopy.country;
      this.selectedAccountCopy.billingAddress1 = this.selectedAccountCopy.address1;
      this.selectedAccountCopy.billingAddress2 = this.selectedAccountCopy.address2;
      this.selectedAccountCopy.billingCity = this.selectedAccountCopy.city;
      this.selectedAccountCopy.billingState = this.selectedAccountCopy.state;
      this.selectedAccountCopy.billingZipCode = this.selectedAccountCopy.zipCode;
    }
  }


  isAccountFormValid() {
    let stateValid : boolean = true;
    this.log.debug("this.selectedAccountCopy.billingCountry: " + this.selectedAccountCopy.billingCountry);
    if (this.selectedAccountCopy.billingCountry=== 'United States' || this.selectedAccountCopy.billingCountry === 'Canada') {
      this.log.debug("this.selectedAccountCopy.billingState:" + this.selectedAccountCopy.billingState)
      if (this.selectedAccountCopy.billingState)
        stateValid = true;
      else
        stateValid = false
    }

    this.log.debug("billing stateValid: " + stateValid);
    this.log.debug("this.selectedAccountCopy.billingZip:" + this.selectedAccountCopy.billingZipCode);
    this.log.debug("this.selectedAccountCopy.billingAddr1:" + this.selectedAccountCopy.billingAddress1);
    this.log.debug("this.selectedAccountCopy.billingCity:" + this.selectedAccountCopy.billingCity);
    this.log.debug("this.selectedAccountCopy.billingFirstName:" + this.selectedAccountCopy.billingFirstName);
    this.log.debug("this.selectedAccountCopy.billingLastName:" + this.selectedAccountCopy.billingLastName)
    this.log.debug("this.selectedAccountCopy.billingEmail:" + this.selectedAccountCopy.billingEmail)
    this.log.debug("this.selectedAccountCopy.billingPhone:" + this.selectedAccountCopy.billingPhone);
    this.log.debug("this.accountForm.valid: " + this.accountForm.valid);

    return stateValid && this.accountForm.valid;
  }

  isTierFormValid() {
    const isStandardAccountValid = this.selectedAccountCopy.accountType === this.ACCOUNT_TYPE_STANDARD && this.tier;
    const isNonStandardAccountValid =
      this.selectedAccountCopy.accountType === this.ACCOUNT_TYPE_NON_STANDARD &&
      this.customTier &&
      !!this.customTier.monthlyFee &&
      !!this.customTier.queryAllowance &&
      !!this.customTier.overageCharge;

    return isStandardAccountValid || isNonStandardAccountValid;
  }

  isAllowedToEditTier() {
    return !this.tierBeingEdited &&
      this.selectedAccountCopy.accountType === this.ACCOUNT_TYPE_STANDARD &&
      new Date().getUTCDate() <= this.usageTierUpdateLimit;
  }

  enableAccountEdit() {
    this.accountBeingEdited = true;
  }

  enableTierEdit() {
    this.tierBeingEdited = true;
  }

  enableStateEdit() {
    return this.accountBeingEdited === true && !!this.selectedAccountCopy.country;
  }

  enableBillingStateEdit() {
    return this.accountBeingEdited === true && !!this.selectedAccountCopy.billingCountry;
  }

  cancelAccountEdit() {
    this.selectedAccountCopy = JSON.parse(JSON.stringify(this.selectedAccount));
    this.tier = this.selectedAccountCopy.tier;
    this.customTier = this.selectedAccountCopy.custom;
    this.accountBeingEdited = false;

  }

  cancelTierEdit() {
    this.tier = this.selectedAccountCopy.tier;
    this.customTier = this.selectedAccountCopy.custom;
    this.tierBeingEdited = false;
  }

  saveAccount() {
    this.saveModifiedAccount(this.selectedAccountCopy);
    this.accountBeingEdited = false;
  }

  saveTier() {
    this.selectedAccount.tier = this.tier;
    this.selectedAccount.custom = this.customTier;
    this.selectedAccountCopy.tier = this.tier;
    this.selectedAccountCopy.custom = this.customTier;
    this.saveModifiedAccount(this.selectedAccount);
    this.tierBeingEdited = false;
  }

  /**
   * save modified account
   */
  saveModifiedAccount(accountToSave) {
    console.log(accountToSave);
    this.clearMessages();
    
    if (!this.hasDigitsAndLetters(accountToSave.spid, 4)) {
      this.displayErrorMessage(new Message('Error', 'The SPID must be 4 characters.'));
      return false;
    }

    this.accountCompletionService.putAccountCompletion(JSON.stringify(accountToSave)).subscribe(
      res => { console.log(res);
        this.log.debug(`saveMyAccount(): result message=${JSON.stringify(res)}`);
        if (res['status'] === 'fail') {
          const message: any = res['messages'][0];
          const errorMessage = message['message'];
          this.log.error(`failed to save the updated account: ${errorMessage}`);
          this.displayErrorMessage(errorMessage);
          window.scrollTo(0, 0);
        } else {

          this.displaySuccessMessage(
            `Success`,
            `Account ${this.selectedAccount.accountId} has been updated.`);
          this.log.info(`saveEditAccount(): sucessfully updated account(${accountToSave.accountId})`);

        }
      },
      error => {
        this.log.error(`failed to save the modified account: got HttpError=${JSON.stringify(error)}`);
        this.processHttpError(error);
      }
    );

  }

  displayError() {
    this.displayErrorMessage(
      new Message('Error', 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.')
    );
  }

  /*downloadServiceAgreement(version : string) {
    console.log("version: " + version);
    this.accountCompletionService.getServiceAgreement(version);
  }*/

  public downloadServiceAgreement(version: string) {
    this.accountCompletionService.getServiceAgreement(version).subscribe(rsp => {
      console.log("response" + JSON.stringify(rsp));
      const bf = rsp as any;
      var blob = new Blob([bf.content], { type: bf.contentType });
      this.open(blob, bf.contentType, bf.fileName);
    });
  }

  open(file: Blob, contentType: string, filename: string) {
    const nav = (window.navigator as any);

    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(file, filename);
    }
    else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.style.display = 'none';
      const fileURL = URL.createObjectURL(file);
      anchor.href = fileURL;
      anchor.download = filename;
      anchor.click();
    }
  }

  hasDigitsAndLetters(string: string, n: number): boolean {

    if (string === null || string === '') {
      return true;
    } else { //non(alphanumeric + _ )
      return string.replace(/[\W_]/g, '').length === n;
    }
  }

}
